define("settings/components/navigation-sidebar", ["exports", "@ember/component", "@ember/template-factory", "@glimmer/component", "@ember/object", "@ember/service", "later/utils/get-page-from-window"], function (_exports, _component, _templateFactory, _component2, _object, _service, _getPageFromWindow) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5;

  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <section class="o--page__sidebar o--page__sidebar--full">
    <NavigationHeader @slug={{this.lastGroup.slug}} />
    <NavigationList>
      <NavigationListItem
        data-test-id="account-settings"
        @linkTo="overview"
        @title={{t "account.navigation.account_settings"}}
      />
      <NavigationListItem
        class="at--autoPublish__socialSetsGroups at--autoPublishEnable__socialSetsGroups"
        data-test-id="access-groups"
        @linkTo="groups"
        @title={{t "account.navigation.social_sets_groups"}}
      />
      <NavigationListItem
        data-test-id="users"
        @linkTo="users"
        @title={{t "shared_words.users"}}
      />
      <NavigationListItem
        data-test-id="subscription"
        @linkTo="subscription"
        @title={{t "account.navigation.subscription"}}
        {{on "mouseenter" (action "loadPayments")}}
      />
      <NavigationListItem
        data-test-id="notifications-devices"
        @linkTo="devices"
        @title={{t "account.navigation.notifications_devices"}}
      />
      <li class="tAC--sidebar__item u--m__t__lg" data-test-id="logout">
        <Shared::Ui::Button
          class="tAC--sidebar__link qa--sidebar__link--logout"
          @onClick={{this.logout}}
          @text={{t "header.logout"}}
          @type="unstyled"
        />
      </li>
    </NavigationList>
  
    {{#if this.lastGroup}}
      <NavigationFooter
        @slug={{this.lastGroup.slug}}
        @logout={{this.logout}}
        @openChatbot={{this.openChatbot}}
      />
    {{/if}}
  </section>
  
  */
  {
    "id": "zss7OU+e",
    "block": "[[[10,\"section\"],[14,0,\"o--page__sidebar o--page__sidebar--full\"],[12],[1,\"\\n  \"],[8,[39,0],null,[[\"@slug\"],[[30,0,[\"lastGroup\",\"slug\"]]]],null],[1,\"\\n  \"],[8,[39,1],null,null,[[\"default\"],[[[[1,\"\\n    \"],[8,[39,2],[[24,\"data-test-id\",\"account-settings\"]],[[\"@linkTo\",\"@title\"],[\"overview\",[28,[37,3],[\"account.navigation.account_settings\"],null]]],null],[1,\"\\n    \"],[8,[39,2],[[24,0,\"at--autoPublish__socialSetsGroups at--autoPublishEnable__socialSetsGroups\"],[24,\"data-test-id\",\"access-groups\"]],[[\"@linkTo\",\"@title\"],[\"groups\",[28,[37,3],[\"account.navigation.social_sets_groups\"],null]]],null],[1,\"\\n    \"],[8,[39,2],[[24,\"data-test-id\",\"users\"]],[[\"@linkTo\",\"@title\"],[\"users\",[28,[37,3],[\"shared_words.users\"],null]]],null],[1,\"\\n    \"],[8,[39,2],[[24,\"data-test-id\",\"subscription\"],[4,[38,4],[\"mouseenter\",[28,[37,5],[[30,0],\"loadPayments\"],null]],null]],[[\"@linkTo\",\"@title\"],[\"subscription\",[28,[37,3],[\"account.navigation.subscription\"],null]]],null],[1,\"\\n    \"],[8,[39,2],[[24,\"data-test-id\",\"notifications-devices\"]],[[\"@linkTo\",\"@title\"],[\"devices\",[28,[37,3],[\"account.navigation.notifications_devices\"],null]]],null],[1,\"\\n    \"],[10,\"li\"],[14,0,\"tAC--sidebar__item u--m__t__lg\"],[14,\"data-test-id\",\"logout\"],[12],[1,\"\\n      \"],[8,[39,6],[[24,0,\"tAC--sidebar__link qa--sidebar__link--logout\"]],[[\"@onClick\",\"@text\",\"@type\"],[[30,0,[\"logout\"]],[28,[37,3],[\"header.logout\"],null],\"unstyled\"]],null],[1,\"\\n    \"],[13],[1,\"\\n  \"]],[]]]]],[1,\"\\n\\n\"],[41,[30,0,[\"lastGroup\"]],[[[1,\"    \"],[8,[39,8],null,[[\"@slug\",\"@logout\",\"@openChatbot\"],[[30,0,[\"lastGroup\",\"slug\"]],[30,0,[\"logout\"]],[30,0,[\"openChatbot\"]]]],null],[1,\"\\n\"]],[]],null],[13],[1,\"\\n\"]],[],false,[\"navigation-header\",\"navigation-list\",\"navigation-list-item\",\"t\",\"on\",\"action\",\"shared/ui/button\",\"if\",\"navigation-footer\"]]",
    "moduleName": "settings/components/navigation-sidebar.hbs",
    "isStrictMode": false
  });

  let NavigationSidebar = (_class = class NavigationSidebar extends _component2.default {
    constructor() {
      super(...arguments);

      _initializerDefineProperty(this, "ada", _descriptor, this);

      _initializerDefineProperty(this, "auth", _descriptor2, this);

      _initializerDefineProperty(this, "payment", _descriptor3, this);

      _initializerDefineProperty(this, "settings", _descriptor4, this);

      _initializerDefineProperty(this, "integrationsQueue", _descriptor5, this);
    }

    get lastGroup() {
      return this.auth.lastGroup;
    }

    loadPayments() {
      this.payment.retrieve.perform();
    }

    logout() {
      this.auth.logout();
    }

    openChatbot(location) {
      this.integrationsQueue.addToQueue(this.ada.name, true);
      this.ada.open(location, (0, _getPageFromWindow.default)());
    }

  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "ada", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "payment", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "settings", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "integrationsQueue", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class.prototype, "loadPayments", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "loadPayments"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "logout", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "logout"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "openChatbot", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "openChatbot"), _class.prototype)), _class);
  _exports.default = NavigationSidebar;
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, NavigationSidebar);
});